import React from 'react';
import { Helmet } from 'react-helmet-async';

export const Terms: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service | Chinese Food Maps</title>
        <meta name="description" content="Read our detailed terms of service to understand your rights and responsibilities when using Chinese Food Maps. This document outlines our policies on acceptable use and content guidelines." />
        <meta property="og:title" content="Terms of Service | Chinese Food Maps" />
        <meta property="og:description" content="Read our detailed terms of service to understand your rights and responsibilities when using Chinese Food Maps. This document outlines our policies on acceptable use and content guidelines." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://chinesefoodmaps.com/terms" />
        <meta property="og:image" content="https://cdn-icons-png.flaticon.com/512/2548/2548242.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Terms of Service | Chinese Food Maps" />
        <meta name="twitter:description" content="Read our detailed terms of service to understand your rights and responsibilities when using Chinese Food Maps." />
        <meta name="twitter:image" content="https://cdn-icons-png.flaticon.com/512/2548/2548242.png" />
        <link rel="canonical" href="https://chinesefoodmaps.com/terms" />
      </Helmet>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 text-red-900">Terms of Service</h1>
        
        <div className="bg-white rounded-lg shadow-md p-6 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Acceptance of Terms</h2>
            <p className="text-gray-700 mb-4">
              By accessing and using Chinese Food Maps, you accept and agree to be bound by these Terms of Service and our Privacy Policy. Our service is designed to help users find Chinese restaurants and learn about Chinese cuisine.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Use License</h2>
            <p className="text-gray-700 mb-4">
              Chinese Food Maps grants you a personal, non-exclusive, non-transferable license to use our service for finding local Chinese restaurants. This license does not allow you to modify, distribute, or create derivative works of our content.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Restaurant Information</h2>
            <p className="text-gray-700 mb-4">
              While we strive to maintain accurate and up-to-date information about Chinese restaurants, including menus, hours, and contact details, we cannot guarantee complete accuracy. Users should verify critical information directly with the restaurants.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">User Responsibilities</h2>
            <p className="text-gray-700 mb-4">
              Users agree to provide accurate location information when using our service. Any attempt to manipulate our system or provide false information is prohibited. Users are responsible for maintaining the confidentiality of their account information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Limitations</h2>
            <p className="text-gray-700 mb-4">
              Chinese Food Maps shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service. This includes but is not limited to damages from errors in restaurant information or service unavailability.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Content Guidelines</h2>
            <p className="text-gray-700 mb-4">
              Users who contribute reviews or comments must ensure their content is accurate, respectful, and relevant to Chinese cuisine and restaurants. We reserve the right to remove any content that violates these guidelines.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-red-800">Changes to Terms</h2>
            <p className="text-gray-700">
              We reserve the right to modify these terms at any time. Continued use of Chinese Food Maps after changes constitutes acceptance of the modified terms. Users will be notified of significant changes to these terms.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};